/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_24_HoursInputs */

const en_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 Hours`)
};

const fr_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 heures`)
};

const de_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 Stunden`)
};

const it_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 ore`)
};

const ru_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 часа`)
};

const es_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 horas`)
};

const zh_cn2_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24小时`)
};

const ja_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24時間`)
};

const hi_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 घंटे`)
};

const pt_pt2_date_range_24_hours = /** @type {(inputs: Date_Range_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 horas`)
};

/**
* | output |
* | --- |
* | "24 Hours" |
*
* @param {Date_Range_24_HoursInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_24_hours = /** @type {((inputs?: Date_Range_24_HoursInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_24_HoursInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_date_range_24_hours(inputs)
	if (locale === "de") return de_date_range_24_hours(inputs)
	if (locale === "it") return it_date_range_24_hours(inputs)
	if (locale === "ru") return ru_date_range_24_hours(inputs)
	if (locale === "es") return es_date_range_24_hours(inputs)
	if (locale === "zh-CN") return zh_cn2_date_range_24_hours(inputs)
	if (locale === "ja") return ja_date_range_24_hours(inputs)
	if (locale === "hi") return hi_date_range_24_hours(inputs)
	if (locale === "pt-PT") return pt_pt2_date_range_24_hours(inputs)
	return en_date_range_24_hours(inputs)
});